import * as React from 'react';
import { Popup } from 'semantic-ui-react';
import * as styles from './ActionButtonsContainer.scss';

interface ActionButtonsContainerProps {
    triggerComponent: React.ReactNode;
    menuComponent: any;
    onOpen?: (event: React.SyntheticEvent, data: any) => void;
    onClose?: (event: React.SyntheticEvent, data: any) => void;
    position?: any;
    open?: boolean;
}

class ActionButtonsContainer extends React.PureComponent<ActionButtonsContainerProps> {
    render(): React.ReactElement {
        const {
            triggerComponent, menuComponent, onOpen, onClose, position, open,
        } = this.props;
        return (
            <Popup
                className={`${styles.noPadding} ${styles.zIndexFix}`}
                on="click"
                trigger={triggerComponent}
                onClose={onClose}
                onOpen={onOpen}
                basic
                position={position}
                open={open}
            >
                <Popup.Content>{menuComponent}</Popup.Content>
            </Popup>
        );
    }
}

export default ActionButtonsContainer;
